/**
 * Klassenname der aktiven Off-Canvas-Navigation
 */
export const OFF_CANVAS_ACTIVE_CLASSNAME = `off-canvas-active` as const;

/**
 * Standard Autoplay interval
 */
export const AUTOPLAY_INTERVAL = 3000 as const;
